import React, { useState, useEffect } from "react";
import Aux from "../../../hoc/Auxilliary";
import { useParams } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Button,
  Grid,
  TablePagination,
  TextField,
} from "@material-ui/core/";
import { Link } from "react-router-dom";
import moment from "moment";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import { useSelector, useDispatch } from "react-redux";
import localizedStrings from "../../../utils/localize";
import {
  getApplicationDetails,
  getCheckListData,
  getApplicationDocuments,
  getOptionList,
  getUploadedData,
  getAnotherOptionList,
  saveDocumentUploadData,
  updateCheckListStatus,
  updateApplicationStatus,
} from "../../../reduxSlices/applicationSlice";
import {
  applicationStatusOptionList,
  buildDecisionLetterDisplayName,
} from "../../../utils/general";
import MessageIndicator from "../../SnackBar";
import { isObjectEmpty } from "../../../utils/general";
import { formatDateInChicagoTimezone } from "../../../helpers/dateLogic";

const useStyles = makeStyles({
  TableControl: {
    display: "flex",
    flexDirection: "column",
  },
  formControl: {
    color: "white",
  },
  classConatiner: {
    padding: "1rem 0",
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
  classFont: {
    fontSize: "1.8rem",
    fontWeight: 500,
    flex: 1,
  },
  classFont1: {
    fontSize: "1.1rem",
    fontWeight: 600,
    flex: 1,
  },
  backButtonContainer: {
    display: "flex",
    justifyContent: "flex-end",
    padding: "10px",
  },
  acceptedButtonContainer: {
    display: "flex",
    justifyContent: "center",
    padding: "10px",
  },
});

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#005598",
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

var fileTypes = {
  docx: "data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64,",
  pdf: "data:application/pdf;base64,",
  jpg: "data:image/jpeg;base64,",
  jpeg: "data:image/jpeg;base64,",
  png: "data:image/png;base64,",
  xlsx: "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,",
  txt: "data:text/plain;base64,",
  xml: "data:application/xml;base64,",
  zip: "data:application/zip;base64,",
  yml: "data:text/yaml;base64,",
  zir: "data:application/vnd.zul;base64,",
};

const ApplicationDetail = (props) => {
  const dispatch = useDispatch();
  const classes = useStyles(props);
  const { applicantId, applicationId } = useParams();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [disableAMO, setDisableAMO] = useState(false);
  const [disableDMO, setDisableDMO] = useState(false);
  const [prospectiveApplication, setProspectiveApplication] = useState([]);
  let [fileData, setFileData] = useState({
    PassportDocument: "",
    PassportName: "",
    applicantId: applicantId,
    newfile: false,
  });
  const [event, setEvent] = useState({
    isEvent: false,
    message: "",
    showSnackbar: false,
  });
  const [error, setError] = useState({
    isError: false,
    message: "",
    showSnackbar: false,
  });
  const [dataFiles, setdataFiles] = useState({});
  const [dataType, setDataType] = useState("");
  const [name, setName] = useState("");
  const [showUploadSection, setShowUploadSection] = useState(false);
  const [itemName, setItemName] = useState(null);
  const applicationDetails = useSelector(
    (state) => state.applicationData.applicationDetails,
  );
  const checkListData = useSelector(
    (state) => state.applicationData.checkListData,
  );
  const applicationDocuments = useSelector(
    (state) => state.applicationData.applicationDocuments,
  );
  const optionList = useSelector((state) => state.applicationData.optionList);
  const anotherOptionList = useSelector(
    (state) => state.applicationData.anotherOptionList,
  );
  const errorMessage = useSelector(
    (state) => state.applicationData.errorMessage,
  );

  const errorStatusCode = useSelector(
    (state) => state.applicationData.errorStatusCode,
  );

  const files = useSelector((state) => state.applicationData.files);

  const language = useSelector((state) => state.language.language);
  localizedStrings.setLanguage(language);

  useEffect(() => {
    localizedStrings.setLanguage(language);
  }, [language]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const customLabelDisplayedRows = ({ from, to, count }) => {
    return `${from}-${to} ${localizedStrings.general.of} ${count}`;
  };

  const funcStatusOptionList = (status) => {
    let value;
    if (anotherOptionList?.length !== 0) {
      anotherOptionList?.map((ele) => {
        if (ele.attributevalue === status) {
          value = ele.value;
        }
        return null;
      });
    }
    value = applicationStatusOptionList(value);
    return value;
  };
  useEffect(() => {
    if (!isObjectEmpty(errorMessage) && errorMessage !== undefined) {
      if (errorStatusCode === 401) {
        let event = {
          isEvent: false,
          message: "Session Expired",
          showSnackbar: true,
        };
        setEvent(event);
        setTimeout(() => {
          handelLogout();
        }, 1600);
      } else {
        let event = {
          isEvent: false,
          message: errorMessage,
          showSnackbar: true,
        };
        setEvent(event);
      }
    }
  }, [errorMessage, errorStatusCode]);
  useEffect(() => {
    // const applicationId = "53d5025e-1c24-ef11-840b-000d3af48bfb";
    if (applicationId && applicantId) {
      dispatch(getApplicationDetails(applicationId));
      dispatch(getCheckListData(applicationId, applicantId));
      dispatch(getApplicationDocuments(applicationId));
    }
  }, [applicationId]);
  useEffect(() => {
    if (itemName?.ses_checklistitemname && applicantId) {
      dispatch(getUploadedData(applicantId, itemName.ses_checklistitemname));
    }
  }, [itemName]);

  const funcOptionList = (status) => {
    let value;

    console.log(optionList, "optionList");
    if (Object.keys(optionList).length > 0) {
      optionList?.map((ele) => {
        if (ele.attributevalue === status) {
          value = ele.value;
        }
        return null;
      });
    }

    if (value === "Pending") {
      value = `${localizedStrings.applicationpage.pending}`;
    }
    if (value === "Waived") {
      value = `${localizedStrings.applicationpage.waived}`;
    }
    if (value === "Received") {
      value = `${localizedStrings.applicationpage.received}`;
    }
    if (value === "Under Review") {
      value = `${localizedStrings.applicationpage.underreview}`;
    }
    return value;
  };

  useEffect(() => {
    const entity = "ses_admissionchecklist";
    const attributename = "ses_checkliststatus";
    dispatch(getOptionList(entity, attributename));
  }, [dispatch]);

  useEffect(() => {
    let newDataFiles = { ...files };
    var Passport = newDataFiles?.Passport?.value[0];
    let PassportDocumentBody, PassportFilename;
    if (Passport != undefined || Passport?.length != 0) {
      PassportDocumentBody = Passport?.documentbody;
      PassportFilename = Passport?.filename;
    }
    var newfiles = {
      PassportFilename: PassportFilename,
      PassportDocumentBody: PassportDocumentBody,
    };
    setdataFiles(newfiles);
    var oldfiles = {
      PassportName: PassportFilename,
      PassportDocument: PassportDocumentBody,
    };

    setName(oldfiles.PassportName);

    var filetype;
    if (oldfiles.PassportName != undefined) {
      filetype = oldfiles.PassportName.split(".")[1];
    }

    for (const sec in fileTypes) {
      if (sec === filetype) {
        setDataType(fileTypes[sec]);
      }
    }

    setFileData(oldfiles);
  }, [files]);

  useEffect(() => {
    const entity = "ses_application";
    const attributename = "ses_applicationstatus";
    dispatch(getAnotherOptionList(entity, attributename));
  }, [dispatch]);

  const handleOpen = (item) => {
    setShowUploadSection(true);
    setItemName(item);
  };

  const handleSave = () => {
    let docproofs = fileData;
    docproofs.applicantId = applicantId;
    docproofs.checklistname = itemName.ses_checklistitemname;
    dispatch(saveDocumentUploadData(docproofs));
    dispatch(updateCheckListStatus(itemName));
    setTimeout(() => {
      dispatch(getUploadedData(applicantId, itemName.ses_checklistitemname));
    }, 2000);
  };
  const handleCancel = () => {
    setShowUploadSection(false);
  };

  let tableData = "";

  if (checkListData?.checkListResponse?.length > 0) {
    if (checkListData.checkListResponse) {
      if (Array.isArray(checkListData.checkListResponse)) {
        tableData =
          checkListData?.checkListResponse?.length > 0
            ? checkListData?.checkListResponse?.map((element, index) => {
                return (
                  <StyledTableRow key={index}>
                    <StyledTableCell component="th" scope="row">
                      {element.ses_checklistitemname}
                    </StyledTableCell>
                    <StyledTableCell>{element.ses_note}</StyledTableCell>
                    <StyledTableCell>
                      {element?.ses_requiredby !== null
                        ? moment.utc(element?.ses_requiredby, "YYYY-MM-DD").format("YYYY/MM/DD")
                        : null}
                    </StyledTableCell>
                    <StyledTableCell>
                      {funcOptionList(element.ses_checkliststatus)}
                    </StyledTableCell>
                    <StyledTableCell>
                      {element?.modifiedon !== null
                        ? moment.utc(element?.modifiedon, "YYYY-MM-DD").format("YYYY/MM/DD")
                        : null}
                    </StyledTableCell>
                    <StyledTableCell>
                      {(element.ses_checkliststatus === 284210000 ||
                        element.ses_checkliststatus === 284210002) &&
                        `${localizedStrings.applicationpage.none}`}
                      {element.ses_checkliststatus === 284210001 &&
                        element.usb_fileuploadrequired === true && (
                          <span
                            onClick={() => handleOpen(element)}
                            style={{
                              color: "blue",
                              textDecoration: "underline",
                              cursor: "pointer",
                            }}
                          >
                            {localizedStrings.applicationpage.uploaddocument}
                          </span>
                        )}
                      {element.ses_checkliststatus === 284210001 &&
                        element.usb_fileuploadrequired === false &&
                        `${localizedStrings.applicationpage.seenotes}`}
                    </StyledTableCell>
                  </StyledTableRow>
                );
              })
            : null;
      }
    }
  }

  function getBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  }

  const handleFile = async (event) => {
    let newFileData = { ...fileData };
    event.persist();
    newFileData.PassportName =
      "addnew_" +
      checkListData.contacts[0].lastname +
      "," +
      checkListData?.contacts[0]?.firstname +
      "," +
      checkListData?.applications[0]?.ses_application +
      "," +
      moment(new Date()).format("YYYY-MM-DD") +
      `.${event.target.files[0].name.split(".")[1]}`;
    await getBase64(event.target.files[0]).then((data) => {
      var base64encodedData = data.split(",")[1];
      newFileData.PassportDocument = base64encodedData.replace(
        "data:application/pdf;base64,",
        "",
      );
    });
    newFileData.newfile = true;
    setFileData(newFileData);
  };

  const handleClose = () => {
    if (event.showSnackbar) {
      let eventCopy = { ...event };
      eventCopy.showSnackbar = false;
      setEvent(eventCopy);
    } else {
      let errorCopy = { ...error };
      errorCopy.showSnackbar = false;
      setError(errorCopy);
    }
  };

  const handleClick = () => {
    document.getElementById("hiddenFileInput").click();
  };

  const handleAccpectOffer = () => {
    let updateStatus = {
      ses_appplicantionId: applicationId,
      ses_applicationstatus: 284210007,
    };
    dispatch(updateApplicationStatus(updateStatus));
    setDisableAMO(true);
    setDisableDMO(true);
    setTimeout(() => {
      window.location.reload();
    }, 2000);
  };

  const handleDeclineOffer = () => {
    let updateStatus = {
      ses_appplicantionId: applicationId,
      ses_applicationstatus: 284210013,
      usb_inactivereason: 943240004,
    };
    dispatch(updateApplicationStatus(updateStatus));
    setDisableDMO(true);
    setDisableAMO(true);
    setTimeout(() => {
      window.location.reload();
    }, 2000);
  };

  return (
    <Aux>
      <MessageIndicator
        open={event.showSnackbar || error.showSnackbar}
        message={error.message || event.message}
        handleClose={handleClose}
      />
      <Grid container justifyContent="center">
        <Grid item xs={10}>
          <Grid className={classes.classConatiner}>
            <Typography component="div" className={classes.classFont}>
              {localizedStrings.applicationpage.myapplication}
            </Typography>
            <Typography
              component="div"
              className={classes.classFont}
              style={{ fontSize: "1rem" }}
            >
              <span className={classes.classFont1}>
                {" "}
                {localizedStrings.applicationpage.creationdate}:
              </span>{" "}
              {applicationDetails?.createdon !== null
                ? formatDateInChicagoTimezone(applicationDetails?.createdon)
                : null}
            </Typography>
            <Typography
              component="div"
              className={classes.classFont}
              style={{ fontSize: "1rem" }}
            >
              <span className={classes.classFont1}>
                {" "}
                {localizedStrings.applicationpage.applicationprogram}:{" "}
              </span>{" "}
              {applicationDetails?.ses_certificationprogramname}
            </Typography>
            <Typography
              component="div"
              className={classes.classFont}
              style={{ fontSize: "1rem" }}
            >
              <span className={classes.classFont1}>
                {" "}
                {localizedStrings.applicationpage.yearandterm}:
              </span>{" "}
              {
                applicationDetails[
                  "_ses_academicperiodid_value@OData.Community.Display.V1.FormattedValue"
                ]
              }
            </Typography>
            <Typography
              component="div"
              className={classes.classFont}
              style={{ fontSize: "1rem" }}
            >
              <span className={classes.classFont1}>
                {" "}
                {localizedStrings.applicationpage.submissiondate}:{" "}
              </span>{" "}
              {applicationDetails?.usb_applicationsubmitteddate !== null
                ? formatDateInChicagoTimezone(
                    applicationDetails?.usb_applicationsubmitteddate,
                  )
                : null}
            </Typography>
            <Typography
              component="div"
              className={classes.classFont}
              style={{ fontSize: "1rem" }}
            >
              <span className={classes.classFont1}>
                {" "}
                {localizedStrings.applicationpage.deadline}:
              </span>{" "}
              {applicationDetails?.usb_applicationdeadlinedate !== null
                ? formatDateInChicagoTimezone(
                    applicationDetails?.usb_applicationdeadlinedate,
                  )
                : null}
            </Typography>
            <Typography
              component="div"
              className={classes.classFont}
              style={{ fontSize: "1rem" }}
            >
              <span className={classes.classFont1}>
                {" "}
                {localizedStrings.applicationpage.status}:{" "}
              </span>{" "}
              {funcStatusOptionList(applicationDetails?.ses_applicationstatus)}
            </Typography>
          </Grid>
          <div className={classes.backButtonContainer}>
            <Link to="/prospective/landingpage">
              {" "}
              <Button variant="contained" color="primary">
                {localizedStrings.applicationpage.backpage}
              </Button>
            </Link>
          </div>
          <Typography
            component="div"
            className={classes.classFont1}
            style={{ fontSize: "1rem" }}
          >
            {localizedStrings.applicationpage.checklist}:
          </Typography>
          <TableContainer
            component={Paper}
            style={{ minHeight: "40vh", marginBottom: "10px" }}
          >
            <Table aria-label="customized table">
              <TableHead>
                <TableRow>
                  <StyledTableCell>
                    {localizedStrings.applicationpage.item}
                  </StyledTableCell>
                  <StyledTableCell>
                    {localizedStrings.applicationpage.notes}
                  </StyledTableCell>
                  <StyledTableCell>
                    {localizedStrings.applicationpage.duedate}
                  </StyledTableCell>
                  <StyledTableCell>
                    {localizedStrings.applicationpage.status}
                  </StyledTableCell>
                  <StyledTableCell>
                    {localizedStrings.applicationpage.lastupdated}
                  </StyledTableCell>
                  <StyledTableCell>
                    {localizedStrings.applicationpage.myactionneeded}
                  </StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>{tableData}</TableBody>
            </Table>

            <TablePagination
              rowsPerPageOptions={[5, 10, 25, 100]}
              component="div"
              count={
                prospectiveApplication.length > 0
                  ? prospectiveApplication.length
                  : 0
              }
              rowsPerPage={rowsPerPage}
              page={page}
              onChangePage={handleChangePage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
              labelRowsPerPage={
                <span style={{ textTransform: "none" }}>
                  {localizedStrings.rows.rowsperpage}
                </span>
              }
              labelDisplayedRows={customLabelDisplayedRows}
            />
          </TableContainer>

          {showUploadSection && (
            <TableContainer
              component={Paper}
              style={{
                minHeight: "10vh",
                marginBottom: "10px",
                overflow: "hidden",
              }}
            >
              <div
                style={{
                  margin: "8px",
                  fontSize: "16px",
                }}
              >
                Directives pour le téléversement de documents : Tous les
                documents que tu téléverses doivent être au format PDF, Word ou
                JPEG et sous forme de fichier unique. Par exemple, si ton
                passeport comporte deux (2) pages, il doit être téléversé comme
                un seul fichier et non de deux (2) fichiers distincts. Essaie
                d'éviter de téléverser des copies du même document.
              </div>
              <Table aria-label="customized table">
                <TableRow>
                  <TableCell>{itemName?.ses_checklistitemname}</TableCell>
                  <TableCell>
                    {" "}
                    <button onClick={handleClick}>
                      Sélectionner un fichier
                    </button>
                  </TableCell>
                  <TableCell>
                    <span style={{ display: "flex" }}>
                      <input
                        type="file"
                        id="hiddenFileInput"
                        name="Passport"
                        style={{ display: "none" }}
                        onChange={handleFile}
                      />
                    </span>
                  </TableCell>
                  <TableCell>
                    {" "}
                    {fileData.PassportDocument != undefined && (
                      <span
                        style={{
                          position: "relative",
                        }}
                      >
                        <a
                          href={dataType + fileData.PassportDocument}
                          id="download"
                          download={name}
                        >
                          {name}
                        </a>
                      </span>
                    )}
                  </TableCell>
                </TableRow>
              </Table>
              <br />

              <Grid container spacing={2} style={{ paddingLeft: "30rem" }}>
                <Grid item>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleCancel}
                  >
                    {localizedStrings.applicationpage.cancel}
                  </Button>
                </Grid>

                <Grid item>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSave}
                    disabled={
                      !fileData.newfile || fileData.newfile === undefined
                    }
                  >
                    {localizedStrings.applicationpage.upload}
                  </Button>
                </Grid>
              </Grid>

              <br />
            </TableContainer>
          )}

          {applicationDocuments.length > 0 && (
            <>
              <br />
              <div style={{ fontSize: "18px" }}>
                {localizedStrings.applicationpage.decisionText}
                <br />
                <br />
                <span style={{ fontWeight: 600 }}>
                  {localizedStrings.applicationpage.decisionletters}
                </span>
                {applicationDocuments?.map((element, index) => {
                  const decisionLetterName = buildDecisionLetterDisplayName({
                    status: applicationDetails?.ses_applicationstatus,
                    firstName:
                      checkListData?.contacts?.[0]?.firstname ||
                      applicationDetails?.firstname ||
                      "",
                    lastName:
                      checkListData?.contacts?.[0]?.lastname ||
                      applicationDetails?.lastname ||
                      "",
                    academicPeriod:
                      applicationDetails?.[
                        "_ses_academicperiodid_value@OData.Community.Display.V1.FormattedValue"
                      ] ||
                      applicationDetails?.ses_academicperiodname ||
                      "",
                  });

                  return (
                    <div key={index}>
                      <a
                        href={
                          "data:application/pdf;base64," +
                          element?.fileName?.response?.value
                        }
                        id="download"
                        download={decisionLetterName}
                      >
                        {decisionLetterName}
                      </a>
                    </div>
                  );
                })}
              </div>
              {[284210004, 284210005].includes(
                applicationDetails.ses_applicationstatus,
              ) &&
                checkListData?.applications?.length > 0 &&
                checkListData?.applications[0]?.ses_dateaccepted === null && (
                  <div className={classes.acceptedButtonContainer}>
                    <Button
                      variant="contained"
                      color="primary"
                      style={{ marginRight: 10 }}
                      onClick={handleDeclineOffer}
                      disabled={disableDMO}
                    >
                      {localizedStrings.applicationpage.declinemyoffer}
                    </Button>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleAccpectOffer}
                      disabled={disableAMO}
                    >
                      {localizedStrings.applicationpage.acceptmyoffer}
                    </Button>
                  </div>
                )}
            </>
          )}
          <br />
        </Grid>
      </Grid>
    </Aux>
  );
};

export default ApplicationDetail;
